import { IconName } from '@optimus-web/icons';

export enum Route {
    Checkout = 'checkout',
    Confirmation = 'confirmation',
    Dates = 'dates',
    Properties = 'properties',
    Rates = 'rates',
    SpaceCategories = 'categories',
    Summary = 'summary',
}

enum RouteTextKey {
    Checkout = 'DetailPlural',
    Confirmation = 'Confirmation',
    Dates = 'DatePlural',
    Properties = 'Properties',
    Rates = 'RatePlural',
    SpaceCategories = 'Categories',
    Summary = 'Summary',
}

export enum RouteIcon {
    Checkout = IconName.Profile,
    Dates = IconName.Calendar,
    Properties = IconName.Location,
    Rates = IconName.Pricing,
    SpaceCategories = IconName.Room,
    Summary = IconName.SummaryOrder,
}

export interface RouteConfiguration {
    name: Route;
    nameKey: RouteTextKey;
    order: number;
    icon?: RouteIcon;
}

export const RouteConfig: Record<Route, RouteConfiguration> = {
    [Route.Dates]: {
        name: Route.Dates,
        order: 0,
        nameKey: RouteTextKey.Dates,
        icon: RouteIcon.Dates,
    },
    [Route.Properties]: {
        name: Route.Properties,
        order: 1,
        nameKey: RouteTextKey.Properties,
        icon: RouteIcon.Properties,
    },
    [Route.SpaceCategories]: {
        name: Route.SpaceCategories,
        order: 2,
        nameKey: RouteTextKey.SpaceCategories,
        icon: RouteIcon.SpaceCategories,
    },
    [Route.Rates]: {
        name: Route.Rates,
        order: 3,
        nameKey: RouteTextKey.Rates,
        icon: RouteIcon.Rates,
    },
    [Route.Summary]: {
        name: Route.Summary,
        order: 4,
        nameKey: RouteTextKey.Summary,
        icon: RouteIcon.Summary,
    },
    [Route.Checkout]: {
        name: Route.Checkout,
        order: 5,
        nameKey: RouteTextKey.Checkout,
        icon: RouteIcon.Checkout,
    },
    [Route.Confirmation]: {
        name: Route.Confirmation,
        order: 6,
        nameKey: RouteTextKey.Confirmation,
    },
};
